import React from 'react'
import PropTypes from 'prop-types'
import { extractYoutubeID } from '../../../common/utils'
import { generateElementId } from '../../../common/helpers'
import EnhancedVideoPlayer from '../EnhancedVideoPlayer'

const ClientStoryLayout = ({ title, text, link }) => {
  const youtubeId = extractYoutubeID(link)

  return (
    <div
      className="mx-4 my-12 max-w-screen-sm md:mx-auto"
      id={`client-story-${generateElementId(title)}`}
    >
      <div className="max-w-4xl px-4 text-center text-gray-500 sm:m-auto lg:px-0">
        <h1 className="text-4xl leading-11 text-blue-700" data-testid="title">
          {title}
        </h1>
        <p className="my-10 text-base text-blue-700" data-testid="text">
          {text}
        </p>
        <div className="mt-12 mb-8 h-44 md:h-84 lg:h-88" data-testid="video">
          <EnhancedVideoPlayer
            light={`https://img.youtube.com/vi/${youtubeId}/sddefault.jpg`}
            playing
            controls
            src={link}
            defer={false}
            isInModal={false}
          />
        </div>
        <a
          className="text-sm hover:text-blue-700"
          href="/testimonials/"
          data-testid="videos-link"
        >
          See more videos
        </a>
      </div>
    </div>
  )
}

ClientStoryLayout.defaultProps = {
  text: '',
  link: '',
}

ClientStoryLayout.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  link: PropTypes.string,
}
export default ClientStoryLayout
